module.exports = __webpack_public_path__ + "img/19.37fe064f.jpg";